<template>
    <admin-layout class="canvas-elements" v-if="elements">

        <app-content-pane class="ml-3">

            <template #title>
                <div class="px-4 pt-3">
                    <h1 class="mb-2">
                        All {{ type_name_plural }}
                    </h1>
                    <h6 class="text-muted">
                        <strong>All {{ type_name_plural }}</strong>
                    </h6>
                </div>
                <hr class="mb-0">
                <template v-if="type">
                    <div class="actions px-4 pt-3 d-flex">

                        <div class="form-group">
                            <select v-model="filters.group_id" class="form-control">
                                <option :value="null">All</option>
                                <option v-for="group in groups" :value="group.id">{{ utils.titleize( group.name ) }}</option>
                            </select>
                        </div>

                        <div class="form-group ml-auto">
                            <inertia-link v-if="is_admin || currentUserAccountTypeIs('paid')"
                                          :href="route('canvas-element.create', {type: type, ...global_url_params})"
                                          class="btn btn-primary d-flex align-items-center">
                                <img src="/images/icons/plus-circle-solid-light.svg" class="mr-1" alt="">
                                Create new {{ type_name }}
                            </inertia-link>
                        </div>
                    </div>
                    <hr class="my-0">
                </template>
            </template>

            <section class="px-3 py-4">

                <div class="row align-items-stretch">
                    <div class="col-6 col-lg-4 d-flex align-items-stretch" v-for="element in elements.data" :key="element.id">
                        <canvas-element-card class="w-100 mb-3"
                                             :show-groups="is_admin"
                                             :element="element" />
                    </div>
                </div>

                <pagination :links="elements.links"/>
            </section>


        </app-content-pane>
    </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import AppContentPane from "@/Components/AppContentPane";
import Pagination from "@/Components/Common/Pagination";
import utils from "@/mixins/utils";
import uploads from "@/mixins/uploads";
import CanvasElementCard from "@/Components/CanvasElement/CanvasElementCard";
import API from "@/API";

export default {
    name: "Index",
    components: {CanvasElementCard, AdminLayout, AppContentPane, Pagination},
    props: ['elements', 'type', 'params'],
    mixins: [uploads, utils],

    data(){
        return {
            is_busy: false,
            groups: [],
            filters: {
                group_id: this.params?.group_id ?? null,
            },
        }
    },

    computed: {
        type_name_plural(){
            switch (this.type) {
                case 'resource': return 'Resources';
                case 'activity': return 'Activities';
            }
            return 'Canvas Elements';
        },
        type_name(){
            switch (this.type) {
                case 'resource': return 'Resource';
                case 'activity': return 'Activity';
            }
            return 'Canvas Element';
        },
    },

    watch: {
        filters: {
            deep: true,
            handler(){
                this.$inertia.visit(this.route('canvas-element.index', {
                    type: this.type,
                    group_id: this.filters.group_id,
                    ...this.global_url_params
                }));
            }
        }
    },

    methods: {

        async fetchGroups(){
            this.groups = await API.groups.bulk({type: ['stage']});
        },

        colTitle( element ){
            if( element.type === 'resource' ){
                if( ['embed', 'link'].indexOf( element.data.type ) >= 0 ) return element.data.url;
                return this.uploads.url( element.data.url );
            }else if( element.type === 'activity' ){
                return this.uploads.url( element.data.file?.url );
            }
            return '';
        },

        colLink( element ){
            if( element.type === 'resource' ){
                if( 'embed' === element.data.type ) return null;
                if( 'link' === element.data.type ) return element.data.url;
                return this.uploads.url( element.data.url );

            }else if( element.type === 'activity' ){
                return this.uploads.url( element.data.file?.url );

            }

            return '';
        },

        colType( element ){
            let type = element.type;
            if( element.type === 'resource' ){
                type += ' : ' + element.data.type;
            }
            return type;
        },

        colTenants( element ){
            const tenants = element.tenants.map(t => t.name).sort();
            return tenants.length ? tenants.join(', ') : '-';
        },

        remove(element){
            if( !confirm(`Are you sure to delete: ${element.name}`) ) return;
            this.is_busy = true;
            this.$inertia.visit(this.route('canvas-element.destroy', {canvas_element: element.id, ...this.global_url_params}), {
                method: 'delete',
                onFinish(){
                    this.is_busy = false;
                }
            });
        }

    },

    async beforeMount() {
        await this.fetchGroups();
    },

    mounted() {
        this.setTitle( this.type_name_plural );
    }


}
</script>

<style lang="scss" scoped>
</style>
